module.exports = __webpack_public_path__ + "img/quicktips4.c1d21ecc.svg";